import React, { useState } from "react";
import Modal from "react-modal";
import ConfirmationModal from "../../../shared/ConfirmationModal";

export default function Venues({ tripVenues, onChange }) {
  const [venueModalOpen, setVenueModalOpen] = useState(false);
  const [venueDraft, setVenueDraft] = useState({ name: "", description: "" });
  const [venueIndexToEdit, setVenueIndexToEdit] = useState(undefined);
  const [confirmDeleteVenueModalOpen, setConfirmDeleteVenueModalOpen] =
    useState(false);
  const [venueIndexToDelete, setVenueIndexToDelete] = useState(undefined);

  const onOpenVenueModal = (index) => {
    setVenueIndexToEdit(index);
    setVenueDraft(
      index === undefined
        ? { name: "", description: "" }
        : { ...tripVenues[index] },
    );
    setVenueModalOpen(true);
  };

  const onCloseVenueModal = () => {
    setVenueModalOpen(false);
    setVenueIndexToEdit(undefined);
    setVenueDraft({ name: "", description: "" });
  };

  const onSaveVenue = () => {
    const newVenues = [...tripVenues];
    if (venueIndexToEdit === undefined) {
      newVenues.push(venueDraft);
    } else {
      newVenues[venueIndexToEdit] = venueDraft;
    }
    onChange("tripVenues", newVenues);
    onCloseVenueModal();
  };

  const onDeleteVenue = () => {
    const newVenues = [...tripVenues];
    newVenues.splice(venueIndexToDelete, 1);
    onChange("tripVenues", newVenues);
    setConfirmDeleteVenueModalOpen(false);
    setVenueIndexToDelete(undefined);
  };

  return (
    <div className="program-settings-page-section">
      <div className="flex flex-align-center mb-16">
        <p className="medium-text fw-700">Venues</p>
        <button
          className="btn custom-btn btn-accent btn-medium ml-16 uppercase-text"
          onClick={() => onOpenVenueModal(undefined)}
        >
          Add
        </button>
      </div>
      <div className="accent-text mb-32" style={{ maxWidth: "800px" }}>
        Add multiple venues for trips. Shluchim will be asked for their venue
        preference based on the venues added here, and will manually be assigned
        to these venues. If only one Shliach-available venue is added, Shluchim
        will not be asked for their preference.
      </div>
      {tripVenues.length > 0 && (
        <div className="venues-grid">
          <div className="venues-grid-header">
            <p>Name</p>
            <p>Description</p>
            <p>Available to Shluchim</p>
            <p />
          </div>
          {tripVenues.map((l, index) => (
            <div className="venues-grid-row" key={index}>
              <p>{l.name}</p>
              <p>{l.description}</p>
              <p>
                {!l.hideFromShluchim && (
                  <i className="material-icons large-text">check</i>
                )}
              </p>
              <p className="text-right flex flex-align-center flex-justify-end">
                <i
                  className="material-icons large-text ml-8 link-text-secondary"
                  onClick={() => onOpenVenueModal(index)}
                >
                  edit
                </i>
                <i
                  className="material-icons large-text ml-8 link-text-secondary"
                  onClick={() => {
                    setVenueIndexToDelete(index);
                    setConfirmDeleteVenueModalOpen(true);
                  }}
                >
                  delete
                </i>
              </p>
            </div>
          ))}
        </div>
      )}
      {venueModalOpen && (
        <Modal className="modal-container" isOpen={venueModalOpen}>
          <div className="modal-card card new-promo-modal">
            <p className="large-text fw-500 mb-16">
              {venueIndexToEdit === undefined ? "New Venue" : "Edit Venue"}
            </p>
            <div className="flex flex-align-center mb-12">
              <label className="accent-text-dark">Name</label>
              <input
                className="custom-input"
                type="text'"
                name="name"
                onChange={(e) =>
                  setVenueDraft({ ...venueDraft, name: e.target.value })
                }
                value={venueDraft.name}
              />
            </div>
            <div className="flex  mb-12">
              <label className="accent-text-dark">Description</label>
              <textarea
                className="custom-input"
                style={{ height: "200px" }}
                name="description"
                onChange={(e) =>
                  setVenueDraft({ ...venueDraft, description: e.target.value })
                }
                value={venueDraft.description}
              />
            </div>
            <div className="flex custom-checkbox-container mb-12">
              <input
                className="custom-checkbox"
                checked={!!venueDraft.hideFromShluchim}
                id="hideFromShluchim"
                name="hideFromShluchim"
                onChange={(e) =>
                  setVenueDraft({
                    ...venueDraft,
                    hideFromShluchim: e.target.checked,
                  })
                }
                type="checkbox"
              />
              <label
                className="flex-align-center fw-400"
                htmlFor="hideFromShluchim"
              >
                Not available to Shluchim
              </label>
            </div>
            <div className="modal-btns flex flex-align-center flex-justify-end mt-16">
              <button
                className="btn link-text uppercase-text fw-500"
                onClick={onCloseVenueModal}
              >
                Cancel
              </button>
              <button
                className="btn link-text uppercase-text fw-500 ml-24"
                disabled={!venueDraft.name}
                onClick={onSaveVenue}
              >
                Save
              </button>
            </div>
          </div>
        </Modal>
      )}
      {confirmDeleteVenueModalOpen && (
        <ConfirmationModal
          cancel={() => {
            setConfirmDeleteVenueModalOpen(false);
            setVenueIndexToDelete(undefined);
          }}
          confirm={onDeleteVenue}
          message="Are you sure you want to delete this venue?"
          show={confirmDeleteVenueModalOpen}
        />
      )}
    </div>
  );
}
